module.exports = __webpack_public_path__ + "img/heart_significance.27b75aeb.png";